module.exports = __webpack_public_path__ + "static/media/IMG_1751.d83e2094.JPG";